import { render, staticRenderFns } from "./novoDesafioSelecionarModelo.vue?vue&type=template&id=21c5a7a6&"
import script from "./novoDesafioSelecionarModelo.vue?vue&type=script&lang=js&"
export * from "./novoDesafioSelecionarModelo.vue?vue&type=script&lang=js&"
import style0 from "./novoDesafioSelecionarModelo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports